(() => {
  // Evita doble inicialización si por error se carga dos veces
  if (window.__UPSELL_XY_PRICE_INIT__) return;
  window.__UPSELL_XY_PRICE_INIT__ = true;

  const TRIGGER_VARIANT_ID = 53817474089289; // X
  const UPSELL_VARIANT_ID  = 53905573019977; // Y

  const COMPARE_CENTS = 2995; // 29,95
  const HALF_CENTS    = 1498; // 14,98

  let GRATIS_WIDTH = null;

  function formatMoney(cents, moneyFormat) {
    const value = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value, moneyFormat);
    }

    const formatWithDelimiters = (amount, precision = 2, thousands = '.', decimal = ',') => {
      const number = (amount / 100).toFixed(precision);
      const parts = number.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };

    const mf = moneyFormat || '{{amount}}';

    if (mf.includes('{{amount_no_decimals}}')) {
      return mf.replace('{{amount_no_decimals}}', formatWithDelimiters(value, 0));
    }
    if (mf.includes('{{amount_with_comma_separator}}')) {
      return mf.replace('{{amount_with_comma_separator}}', formatWithDelimiters(value, 2));
    }
    if (mf.includes('{{amount}}')) {
      return mf.replace('{{amount}}', formatWithDelimiters(value, 2));
    }

    return formatWithDelimiters(value, 2);
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('No se pudo leer /cart.js');
    return res.json();
  }

  function getTriggerQty(cart) {
    return (cart.items || [])
      .filter(i => Number(i.variant_id) === TRIGGER_VARIANT_ID)
      .reduce((acc, i) => acc + (i.quantity || 0), 0);
  }

  function findUpsellNodes() {
    const selector = `[data-id="${UPSELL_VARIANT_ID}"], [data-variant-id="${UPSELL_VARIANT_ID}"]`;
    return Array.from(document.querySelectorAll(selector));
  }

  // ✅ mide el ancho real de "GRATIS"
  function measureGratisWidth(referenceEl) {
    if (GRATIS_WIDTH) return GRATIS_WIDTH;

    const probe = document.createElement('span');
    probe.textContent = 'GRATIS';

    const style = window.getComputedStyle(referenceEl);
    probe.style.font = style.font;
    probe.style.fontSize = style.fontSize;
    probe.style.fontWeight = style.fontWeight;
    probe.style.letterSpacing = style.letterSpacing;
    probe.style.visibility = 'hidden';
    probe.style.position = 'absolute';
    probe.style.whiteSpace = 'nowrap';

    document.body.appendChild(probe);

    GRATIS_WIDTH = probe.getBoundingClientRect().width;

    document.body.removeChild(probe);

    return GRATIS_WIDTH;
  }

  function applyGratisWidth(regularEls) {
    if (!regularEls.length) return;

    const width = measureGratisWidth(regularEls[0]);

    regularEls.forEach(el => {
      el.style.display = 'inline-block';
      el.style.minWidth = width + 'px';
      el.style.textAlign = 'right';
    });
  }

  function clearGratisWidth(regularEls) {
    regularEls.forEach(el => {
      el.style.minWidth = '';
      el.style.display = '';
      el.style.textAlign = '';
    });
  }

  function setUpsellPrice(upsellEl, mode) {

    upsellEl.classList.toggle('upsell--half', mode === 'half');
    upsellEl.classList.toggle('upsell--free', mode === 'free');

    const regularEls = upsellEl.querySelectorAll('.regular-price');
    const compareEls = upsellEl.querySelectorAll('.compare-price');

    const moneyFormat =
      upsellEl.getAttribute('data-money-format') ||
      upsellEl.closest('[data-money-format]')?.getAttribute('data-money-format') ||
      '{{amount}}';

    const compareText = formatMoney(COMPARE_CENTS, moneyFormat);

    compareEls.forEach(el => {
      el.textContent = compareText;
      el.classList.remove('hidden');
    });

    if (mode === 'free') {

      regularEls.forEach(el => {
        el.textContent = 'GRATIS';
      });

      clearGratisWidth(regularEls);

      return;
    }

    if (mode === 'half') {

      const halfText = formatMoney(HALF_CENTS, moneyFormat);

      regularEls.forEach(el => {
        el.textContent = halfText;
      });

      applyGratisWidth(regularEls);

      return;
    }

    clearGratisWidth(regularEls);

    upsellEl.classList.remove('upsell--half', 'upsell--free');
  }

  async function updateUpsellFromCart() {

    const upsells = findUpsellNodes();

    if (!upsells.length) return;

    let cart;

    try {
      cart = await getCart();
    } catch (_) {
      return;
    }

    const qty = getTriggerQty(cart);

    const mode =
      qty >= 2
        ? 'free'
        : qty === 1
        ? 'half'
        : 'default';

    upsells.forEach(el => setUpsellPrice(el, mode));
  }

  document.addEventListener('DOMContentLoaded', updateUpsellFromCart);

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {

    const res = await originalFetch(...args);

    try {

      const url =
        typeof args[0] === 'string'
          ? args[0]
          : args[0]?.url || '';

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      ) {
        setTimeout(updateUpsellFromCart, 50);
        setTimeout(updateUpsellFromCart, 250);
      }

    } catch (_) {}

    return res;
  };

  const mo = new MutationObserver(() => {
    if (findUpsellNodes().length) {
      updateUpsellFromCart();
    }
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();